import { createContext } from 'react'

const { Provider, Consumer } = createContext({
  cookiesAccepted: false,
  setCookieAcceptance: () => {}
})

export { Provider, Consumer }



// WEBPACK FOOTER //
// ./src/components/CookieAcceptance/Context.js